/* eslint-disable no-void */

import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios, { CancelTokenSource } from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';
import { useClientData } from '@/providers/ClientData.provider';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [vp.UserRolesResponse | undefined, (requestParams: vp.UserRolesRequest) => void, () => void];

function useFetchUserRoles({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.UserRolesRequest>();
  const [response, setResponse] = useState<vp.UserRolesResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const {
    response: { TransactionApprovalWorkflowEnabled },
  } = useClientData();

  useEffect(() => {
    if (!vp.toBool(TransactionApprovalWorkflowEnabled)) {
      return;
    }
    const sendRequest = async (requestParams: vp.UserRolesRequest, cancelTokenSource: CancelTokenSource) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');

      const res = await api.fetchUserRoles(requestParams, cancelTokenSource);
      setSendRequest(false);
      setResponse(res);

      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params, source);
    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.UserRolesRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchUserRoles);
